<template>
  <div>
    <div class="row">
      <div class="col-md-12">
          <div class="form-access">
          <a href="#" class="form-back" @click="backParent">
              <i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back
          </a>
          </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
            <h4 class="mt-0 header-title">Message Template</h4>
            <p class="text-muted mb-3">Create template to send message by Whatsapp</p>
            <div class="row">
                <div class="col-lg-6">
                    <div class="form-group row">
                        <label for="template_id" class="col-sm-3 col-form-label text-right">ID</label>
                        <div class="col-sm-9">
                            <input class="form-control" type="text" id="name" v-model="template.template_id">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="url" class="col-sm-3 col-form-label text-right">Url</label>
                        <div class="col-sm-9">
                            <input class="form-control" type="text" id="url" v-model="template.url">
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="message" class="col-sm-3 col-form-label text-right">Message</label>
                        <div class="col-sm-9">
                            <textarea class="form-control" rows="10" id="message" v-model="template.message"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
      </div>
      <div class="card-footer">
        <button class="btn btn-primary pull-right" @click="updateAll" v-if="template.id">Update</button>
        <button class="btn btn-primary pull-right" @click="saveAll" v-else>Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { messageTemplateUrl, getHeader } from '@/config'

export default {
  name: 'MessageTemplateForm',
  props: ['template'],
  data () {
    return {
      name_message: null
    }
  },
  methods: {
    updateAll: function () {
      axios.put(messageTemplateUrl + '/' + this.template.id, this.template, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    saveAll: function () {
      axios.post(messageTemplateUrl, this.template, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '<pre>' + error.response.data + '</pre>',
            'error'
          )
        })
    },
    backParent: function () {
      this.$emit('backClicked')
    }
  }
}
</script>
